import React, { useMemo } from "react";
import { formatCHF } from "../../utils/formatCHF";

/* ============================================================
   PLATEAU CARD
   ------------------------------------------------------------
   Carte visuelle pour afficher un type de plateau.

   Rôle :
   - afficher nom du plateau
   - afficher description
   - afficher prix / personne
   - permettre la sélection du plateau

   NOUVEAU :
   - compatibilité i18n avec plateauxData
   - nom et description peuvent être :
     1) une string simple
     2) un objet { fr, de, en }

   Cette carte ne gère PAS la configuration.
   Elle sert uniquement de sélecteur UX.
   ============================================================ */

function getCurrentLang() {
  if (typeof window === "undefined") return "fr";

  const lang = localStorage.getItem("lang");
  return ["fr", "de", "en"].includes(lang) ? lang : "fr";
}

function getLocalizedValue(value, lang = "fr") {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return value?.[lang] || value?.fr || value?.de || value?.en || "";
  }
  return "";
}

export default function PlateauCard({ plateau, selected, onSelect, t = {} }) {
  const lang = getCurrentLang();

  const nomPlateau = useMemo(
    () => getLocalizedValue(plateau?.nom, lang),
    [plateau, lang]
  );

  const descriptionPlateau = useMemo(
    () => getLocalizedValue(plateau?.description, lang),
    [plateau, lang]
  );

  if (!plateau) return null;

  return (
    <div
      className={`plateau-card ${selected ? "plateau-selected" : ""}`}
      onClick={() => onSelect(plateau)}
    >
      {/* ======================================================
         NOM DU PLATEAU
      ====================================================== */}
      <h3 className="plateau-title">{nomPlateau}</h3>

      {/* ======================================================
         DESCRIPTION
      ====================================================== */}
      {descriptionPlateau ? (
        <p className="plateau-description">{descriptionPlateau}</p>
      ) : null}

      {/* ======================================================
         PRIX PAR PERSONNE
      ====================================================== */}
      <div className="plateau-price">
        {formatCHF(plateau.prix)} /{" "}
        {t?.plateauPeopleUnit || t?.plateauPerPersonShort || "personne"}
      </div>

      {/* ======================================================
         BOUTON VISUEL
         (non interactif — toute la carte est cliquable)
      ====================================================== */}
      <div className="plateau-select-indicator">
        {selected
          ? t?.plateauSelected || "✓ Sélectionné"
          : t?.plateauChoose || "Choisir"}
      </div>
    </div>
  );
}
